export enum CartPaymentMethodEnum {

  BPM = 'BPM',
  Bank = 'BankTransfer',
  /**
   * @deprecated
   * */
  Financig = 'Financing',
  /**
   * @deprecated
   * */
  StripeSplitted3 = 'StripeSplitted3',
  /**
   * @deprecated
   * */
  BankTransferSplitted3 = 'BankTransferSplitted3',
  BPMSplitted2 = 'BPMSplitted2',
  BankTransferSplitted2 = 'BankTransferSplitted2',
    /**
   * @deprecated
   * */
  StripeSplitted2 = 'StripeSplitted2',
    /**
   * @deprecated
   * */
  Stripe = 'Stripe'

}
